import styled, { css } from 'styled-components'
import { Row, Column } from '@sainsburys-tech/bolt'

const ug002Gap = (props) => {
  return props.theme.channel === 'sainsburys' ? props.theme.size.spacing.lg : props.theme.size.spacing.md
}

const UGSliderContainerStyles = css`
  ${(props) =>
    props.hasScroll &&
    css`
      &:div {
        scroll-snap-align: start;
      }

      flex-wrap: nowrap;

      @media screen and (max-width: ${props.theme.size.breakpoint['max-width'].xs}) {
        max-width: 80%;
      }

      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        min-width: ${props.numberOfComponents === 5 ? 220 : 265}%;
      }

      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].lg}) {
        min-width: ${props.numberOfComponents === 5 ? 150 : 180}%;
      }

      @media screen and (min-width: ${props.theme.size.breakpoint['min-width']['2xl']}) {
        min-width: ${props.numberOfComponents === 5 ? 'unset' : '135%'};
      }
    `}
`

export const Container = styled(Row)`
  padding-right: 0;
  margin-left: 0;
  ${(props) =>
    props.consumingGridType === 'ug004'
      ? css`
          justify-content: center;
        `
      : UGSliderContainerStyles}
`

export const FlexColumn = styled(Column)`
  @media screen and (max-width: ${(props) => props.theme.size.breakpoint['max-width'].sm}) {
    ${(props) =>
      (props.consumingGridType === 'ug002' || props.consumingGridType === 'ug001') &&
      props.mobileLayout === 'slider' &&
      css`
        max-width: 100%;
        flex-basis: 90%;
      `}
  }

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    ${(props) =>
      props.consumingGridType === 'ug002'
        ? css`
            max-width: ${!props.isVertical && css`calc(100% / ${props.numberOfComponents} - ${ug002Gap(props)})`};
            overflow: auto;
          `
        : css`
            max-width: calc(100% * (${props.sm || props.md} / 12) - ${props.theme.size.spacing.md});
          `}
    display: flex;
    flex: 1;
  }
`

export const SliderContainer = styled(Column)`
  flex: 1 1 0px;

  ${(props) =>
    css`
      margin-right: ${props.theme.size.spacing.lg};
      @media screen and (max-width: ${props.theme.size.breakpoint['max-width'].sm}) {
        margin-left: 0;
      }
    `}
`

export const SliderWrapper = styled(Row)`
  text-decoration: none;
  justify-content: flex-start;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;

  ${(props) =>
    css`
      margin-bottom: ${props.theme.size.spacing.lg};
    `}
`
